import {Outlet, useLocation} from 'react-router-dom'
import useModal from '@/hooks/modal'
import {Stack} from '@mui/material'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import ProgressiveImage from '@/components/ProgressiveImage'
import React, {Suspense, useEffect, useState} from 'react'
import {lazyWithRetry} from '@/helpers/lazyWithRetry'
import ClueComponent from '@/components/ClueModals'

const MapComponent = lazyWithRetry(() => import('@/components/Map'))

const MAP_ROUTES = ['/main', '/sandbox']

const Index = () => {
  const {modal} = useModal()
  const location = useLocation()
  const isMapRoute = MAP_ROUTES.includes(location.pathname)
  const isMainRoute = location.pathname === '/main'

  const [mapEverVisited, setMapEverVisited] = useState(isMapRoute)
  useEffect(() => {
    if (isMapRoute) setMapEverVisited(true)
  }, [isMapRoute])

  return (
    <Stack
      id="main"
      direction="column"
      height="100%"
      style={{
        backgroundColor: '#191009',
        opacity: modal ? '0.8' : '1',
        maxHeight: '100vh',
      }}
      className="target"
      padding={{
        xs: '16px',
        sm: '16px',
        md: '16px',
        lg: '16px 24px 8px 24px',
        xl: '24px 40px 12px 40px',
        xxl: '24px 48px 12px 48px',
        extra: '24px 56px 12px 56px',
      }}
      boxSizing="border-box">
      <ProgressiveImage
        lowSrc="images/gameBg/bg-low.jpg"
        highSrc="images/gameBg/bg.jpg"
        highSources={[
          {srcSet: 'images/gameBg/bg.avif', type: 'image/avif'},
          {srcSet: 'images/gameBg/bg.webp', type: 'image/webp'},
        ]}
        lowSources={[
          {srcSet: 'images/gameBg/bg-low.avif', type: 'image/avif'},
          {srcSet: 'images/gameBg/bg-low.webp', type: 'image/webp'},
        ]}
        width="1920"
        height="1200"
        wrapStyle={{
          flex: 1,
          width: '100%',
          position: 'absolute',
          inset: 0,
        }}
        imageStyle={{
          height: '100%',
          width: '100%',
        }}
      />

      <Header />
      <Stack
        width="100%"
        overflow="hidden"
        sx={{width: '100%', position: 'relative'}}
        direction="column"
        gap="10px"
        flex="auto">
        {mapEverVisited && (
          <Stack
            position="absolute"
            sx={{inset: 0}}
            zIndex={isMapRoute ? 1 : -1}
            style={{
              visibility: isMapRoute ? 'visible' : 'hidden',
              pointerEvents: isMapRoute ? 'auto' : 'none',
            }}>
            <Suspense fallback={null}>
              <MapComponent />
              {isMainRoute && <ClueComponent />}
            </Suspense>
          </Stack>
        )}

        {!isMapRoute && <Outlet />}
      </Stack>
      <Footer />
    </Stack>
  )
}

export default Index
